import { ScrollArea } from '@/components/ui/scroll-area';

// prettier-ignore
const CURATED_EMOJIS = [
  // Nature & Sky
  '🌅', '🌄', '☀️', '🌙', '⭐', '✨', '💫', '🌈', '⛅', '☁️', '🌕', '🌑',
  '🌗',
  // Elements
  '🔥', '💧', '🌊', '❄️', '⚡', '🌪️', '🌫️', '💨',
  // Weather & Time
  '🌡️', '⛱️', '⛄', '☔', '🌀', '🌬️', '⏳', '⏰', '🧭', '🗺️', '🌍', '🌎',
  // Hearts
  '💚', '💙', '💛', '🧡', '❤️', '💜', '🖤', '🤍', '💖', '💗', '💓', '💕',
  '❤️‍🔥', '❤️‍🩹', '💘', '💝', '💞', '❣️', '🩵',
  // Flowers & Plants
  '🌸', '🌺', '🌷', '🌹', '🌻', '🌼', '💐', '🌿', '🍀', '🍂', '🍁', '🌾',
  '🪴', '🪵', '🌱', '🍃', '🪨',
  // Trees & Nature
  '🌲', '🌳', '🌴', '🌵', '🍄', '🪻', '🪷', '🪹',
  // Animals - Pets
  '🐱', '🐶',
  // Animals - Mammals
  '🦊', '🦌', '🐺', '🦁', '🐯', '🐻', '🐻‍❄️', '🐘', '🦒', '🦓', '🐆', '🐪',
  '🦬', '🐵', '🦍', '🦝', '🐨', '🐼', '🦛', '🦏', '🐎', '🐑', '🐐', '🦘',
  '🐹', '🦡', '🦨', '🐗', '🫎', '🫏', '🦙',
  // Animals - Small
  '🐢', '🦎', '🐇', '🦔', '🐿️', '🦦', '🦥', '🦫', '🐾', '🪺', '🪸', '🦧',
  // Animals - Reptiles & Amphibians
  '🐊', '🐍', '🐉', '🦕', '🦖', '🐸',
  // Animals - Birds & Flying
  '🦋', '🐝', '🐞', '🦩', '🦚', '🦜', '🕊️', '🦅', '🦆', '🦢', '🦉', '🐦',
  '🐧', '🐔', '🐤', '🐣', '🪿', '🦤', '🪶',
  // Animals - Marine
  '🐚', '🐠', '🐬', '🦈', '🐙', '🦑', '🪼', '🦀', '🐳', '🦭', '🐟', '🦐',
  '🐡', '🦞', '🦪',
  // Animals - Bugs
  '🐛', '🐜', '🐌', '🦟', '🦗', '🪲', '🪳', '🕷️', '🕸️', '🦂', '🦠', '🪱',
  // Cosmic & Mystical
  '☄️', '🪐', '🌌', '🛸', '🔭', '🧿', '🪬', '♾️', '⚛️',
  // Abstract & Shapes
  '💎', '🔮', '☯️', '✴️', '❇️', '💠',
  // Scenic & Places
  '👁️', '🎨', '🎭', '🎪', '🎠', '🎡', '🏰', '⛩️', '🗼', '🌉', '🎆', '⛰️',
  '🌋', '🏖️', '🏜️', '🏝️', '🗽', '🗿', '🏕️',
  // Objects - Light & Magic
  '🕯️', '💡', '🔦', '🪔', '🎐', '🎏', '🎀', '🎁', '🪄', '🔑', '🗝️',
  // Music & Art
  '🎵', '🎹', '🎸', '🥁', '🎺', '🎻', '🪘', '📯', '🎬', '🎧', '📸',
  // Fruits & Vegetables
  '🍎', '🍊', '🍋', '🍇', '🍓', '🍑', '🥝', '🍉', '🥭', '🍒', '🫐', '🍌',
  '🍈', '🍐', '🥥', '🥑', '🍅', '🍆', '🌶️', '🌽', '🥕', '🥦', '🍠',
  // Food
  '🍔', '🍕', '🍟', '🍣', '🍜', '🍝', '🍳', '🎂', '🍩', '🍪', '🍦', '🍧',
  '🍞', '🥐', '🍿', '🍯', '🧁', '🍰', '🍫', '🍬', '🍭',
  // Drinks
  '🧃', '🍵', '☕', '🍷', '🥂', '🧊', '🧋', '🍹', '🥛',
  // Celebration
  '🎉', '🎈', '🎃', '🎄', '🎋', '🎍', '🧧',
  // Games & Sports
  '⚽', '🏀', '🎾', '🏆', '🥇', '🎯', '🎲', '🧩', '♟️', '🕹️', '🎳', '🎱',
  // Science
  '🧪', '🧬', '🔬', '🧲',
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  maxHeight?: number;
  disabled?: boolean;
}

export function EmojiPicker({ onSelect, maxHeight = 200, disabled = false }: EmojiPickerProps) {
  return (
    <div className="relative">
      <ScrollArea className="rounded-2xl bg-secondary/30" style={{ height: maxHeight }}>
      <div className="grid grid-cols-6 gap-1 p-3">
        {CURATED_EMOJIS.map((emoji) => (
          <button
            key={emoji}
            onClick={() => !disabled && onSelect(emoji)}
            disabled={disabled}
            className="aspect-square flex items-center justify-center text-2xl rounded-xl hover:bg-secondary active:scale-90 transition-all disabled:opacity-30 disabled:cursor-wait disabled:hover:bg-transparent"
          >
            {emoji}
          </button>
        ))}
      </div>
      </ScrollArea>
      {disabled && (
        <div className="absolute inset-0 flex items-center justify-center bg-background/60 backdrop-blur-sm rounded-2xl">
          <div className="flex flex-col items-center gap-2">
            <svg className="animate-spin h-8 w-8 text-foreground" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-sm text-muted-foreground">Signing...</span>
          </div>
        </div>
      )}
    </div>
  );
}
